import { useEffect } from 'react';
import _ from 'lodash';

interface PropSyncConfig<T> {
  condition: boolean;
  propsValue: T;
  stateValue: T;
  setStateValue: (value: T) => void;
}

export default function usePropSync<T>(config: PropSyncConfig<T>) {
  const { condition, propsValue, stateValue, setStateValue } = config;

  useEffect(() => {
    if (condition && !_.isEqual(propsValue, stateValue)) {
      setStateValue(propsValue);
    }
  }, [condition, propsValue]);
}
